import { render, staticRenderFns } from "./status.vue?vue&type=template&id=1438ca12&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"
import style0 from "./status.vue?vue&type=style&index=0&id=1438ca12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438ca12",
  null
  
)

export default component.exports